export const deviceStaticDefaults = {
  manufacturers: {
    Axis: ['A1011', 'A1601', 'A9161', 'A8004-VE', 'A8105'],
    Generic: ['Generic'],
    'HID GLOBAL legacy': ['Edge', 'V1000', 'V2000', 'HSS'],
    'Mercury security': ['EP4502', 'EP2500', 'LP4502', 'LP2500', 'LP1502'],
  } as Record<string, string[]>,
  defaultDraft: {
    category: 'door-controller' as const,
    manufacturer: 'Mercury security',
    model: 'LP4502',
    name: 'Controller 1',
    description: '',
    ipAddress: '10.40.2.145',
    port: '80',
    macAddress: '00:1A:2B:3C:4D:5E',
    deviceServer: 'localhost',
    username: '',
    password: '',
    connectionType: 'HTTP',
  },
  success: {
    controllerName: 'Controller 1',
    summaryLine:
      'Mercury Security · LP4502 · TCP/IP · 10.40.2.145:3001 · First Floor',
    nextSteps: [
      { id: 'open', label: 'Open controller 1' },
      { id: 'formats', label: 'Review credential formats' },
      { id: 'access-points', label: 'Add access points' },
    ],
  },
  explainability:
    'Based on your site (First floor) and door-controller intent, I prepared a Mercury LP4502 panel with network settings typical for this partition. You can change any field before approving.',
  assistantHint:
    'I’ll help you add a door controller for First floor. Use the steps below, or send the details in one message and I’ll select and fill the form for you to review. Example: “Add an Axis A1001 controller named Second floor at 192.168.1.50 port 80 over HTTP.”',
} as const;
